/**
 * @file 对外相关接口
 * @author putianyi
 */
import 'whatwg-fetch';
import {xhrRequest} from '../../../utils/request';
import {spyRequest as request} from '../log/index';
import {PLATFORMLIVEMAP, PLATFORMMAP, TASKTYPEMAP, ACCOUNTTYPEMAP} from '../config';
import API from './api';

// 获取插件签名
export const getSign = async () => {
    const res = await request(API.GET_EXTERNAL_SIGN, {
        method: 'POSTJSON',
        body: {}
    }).catch(e => {});

    const {errno, data} = res || {};

    if (errno === 0) {
        return Promise.resolve({
            signStr: data.sk,
            timeStamp: data.ts
        });
    }
    return null;

};

/**
 * 获取对外授权列表
*/
export const getExternalAuthList = async () => {
    return request(
        API.GET_EXTERNAL_AUTH_LIST, {
            method: 'POSTJSON',
            body: {
                platform: 0
            }
        }
    );
};

// 获取对外开启授权跳转链接
export const getThirdAuthJumpUrl = async (platform, third_id = '') => {
    return request(
        API.GET_EXTERNAL_AUTH_JUMP_URL, {
            method: 'POSTJSON',
            body: {
                kind: 2,
                platform,
                third_id
            }
        }
    );
};

// 插件登录后上报server
export const reportAuthStatus = async (params = {}) => {
    return request(
        API.REPORT_EXTERNAL_AUTH_STATUS, {
            method: 'POSTJSON',
            body: {
                kind: 1,
                ...params
            }
        }
    );
};

export const checkPort = async (url) => {
    const sign = await getSign();

    return xhrRequest(
        url, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                sign
            }
        }
    );
};

/**
 * 获取本地插件可用port
*/
export const getAvailablePort = async () => {
    const portList = [3876, 8417, 8015, 7535, 7891, 8010, 8673, 8566, 9001, 9567, 10020, 10035];

    for (let i = 0; i < portList.length; i++) {
        const p = portList[i];

        try {
            // const res = await checkPort(`https://huibo.baidu.com/${p}/live/status`);
            const res = await checkPort(`http://127.0.0.1:${p}/live/status`);

            if (res?.code === 0 && res?.data?.updatePort) {
                window.huibo_external_plugin_inner_port = res.data.updatePort;
                break;
            }
        }
        catch (e) {
            console.log('获取本地插件端口失败: ', e);
            continue;
        }
    }
};

/**
 * 获取本地插件版本
 */
export const getPluginVersion = async () => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_inner_port}/system/checkversion`, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk, // 值？
                requestPlat: 'HUI_BO_XING',
                timeStamp: sign?.ts,
                sign
            }
        }
    );
};

/**
 * 插件初始化
 */
export const initPlugin = async () => {
    const sign = await getSign();

    const res = await xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_inner_port}/system/init`, {
        // `https://huibo.baidu.com/${window.huibo_external_plugin_inner_port}/system/init`, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                timeStamp: sign?.ts,
                sign
            }
        }
    ).catch(e => {});

    if (res?.code === 0 && res?.data?.httpPort) {
        window.huibo_external_plugin_port = res.data.httpPort;
        window.huibo_external_plugin_ws_port = res.data.wsPort;
        window.huibo_external_plugin_ws_live_port = res.data.wsLivePort;
    }
};

// 调用插件授权
export const loginByPlugin = async (type) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/startlogin`, {
        // `https://huibo.baidu.com/${window.huibo_external_plugin_port}/live/startlogin`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                data: {
                    // prehand: {   // todo：账户类型切换，后续确认
                    //     userType: 'BUSSINESS' // 当前线上是这个key，后续需要统一成 accountType
                    // }
                },
                timeStamp: sign?.ts,
                sign
            }
        }
    );
};

// 轮询查询插件授权结果
export const checkPluginLoginRes = async (type) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/islogin`, {
        // `https://huibo.baidu.com/${window.huibo_external_plugin_port}/live/islogin`, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                accountType: ACCOUNTTYPEMAP[type], // todo: 首次登录哪里拿
                taskType: TASKTYPEMAP[type],
                timeStamp: sign?.ts,
                sign
            }
        }
    );
};

// 通过插件批量检查授权，返回taskId 轮询查结果
export const batchCheckLogin = async (list) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/checklogin`, {
        // `https://huibo.baidu.com/${window.huibo_external_plugin_port}/live/checklogin`, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                taskType: 1000,
                timeStamp: sign?.ts,
                data: {
                    list: list.map(item => {
                        return {
                            thirdPartyId: item.third_id,
                            livePlatform: PLATFORMLIVEMAP[item.platform],
                            accountType: item.third_type
                        };
                    })
                },
                sign
            }
        }
    );
};

// 轮询查询插件授权结果
export const batchCheckPluginLoginRes = async (taskId) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/selectlogin`, {
        // `https://huibo.baidu.com/${window.huibo_external_plugin_port}/live/selectlogin`, {
            method: 'POST',
            body: {
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                taskId,
                timeStamp: sign?.ts,
                sign
            }
        }
    );
};


// -----------------------------------------------------------------------------
// 商品相关
// -----------------------------------------------------------------------------

/**
 * 获取商品列表
 */
export const getExternalGoodsList = async (params) => {
    return request(
        API.GET_EXTERNAL_GOODS_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 上传商品
 */
export const uploadExternalGoods = async (params) => {
    return request(
        API.UPLOAD_EXTERNAL_GOODS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 插件开始抓取商品
 */
export const getGoodsStartByPlugin = async (type, params = {}) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/startcapture`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                requestPlat: 'HUI_BO_XING',
                accountType: ACCOUNTTYPEMAP[type],
                forceLogin: true,
                data: {
                },
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};

/**
 * 插件轮询商品抓取结果
 */
export const getGoodsListByPlugin = async (type, params = {}) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/captureresult`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                accountType: ACCOUNTTYPEMAP[type],
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                data: {
                },
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};

// -----------------------------------------------------------------------------
// 弹幕、GMV相关
// -----------------------------------------------------------------------------

/**
 * 插件开始抓取GMV
 */
export const getGMVStartByPlugin = async (type, params = {}) => {
    const sign = await getSign();

    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/startgmv`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                accountType: ACCOUNTTYPEMAP[type],
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                data: {
                },
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};

/**
 * 插件停止抓取GMV
 */
export const stopGetGMVListByPlugin = async (type, params = {}) => {
    const sign = await getSign();
    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/stopgmv`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                accountType: ACCOUNTTYPEMAP[type],
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                data: {
                },
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};

/**
 * 商品卡弹卡
 */
export const goodsCardByPlugin = async (type, params = {}) => {
    const sign = await getSign();
    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/showprocard`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                accountType: ACCOUNTTYPEMAP[type],
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};

/**
 * 商品卡弹卡
 */
export const getLiveInfoByPlugin = async (type, params = {}) => {
    const sign = await getSign();
    return xhrRequest(
        `http://127.0.0.1:${window.huibo_external_plugin_port}/live/getliveinfo`, {
            method: 'POST',
            body: {
                taskType: TASKTYPEMAP[type],
                userId: window.huibo_external_auth_uk,
                accountType: ACCOUNTTYPEMAP[type],
                requestPlat: 'HUI_BO_XING',
                forceLogin: true,
                timeStamp: sign?.ts,
                sign,
                ...params
            }
        }
    );
};
